import React from 'react';

const TermsOfService = () => {
    return (
        <div className="legal-page">
            <div className="legal-container container">
                <h1>Terms of Service</h1>
                <p className="legal-updated">Last updated: {new Date().toLocaleDateString()}</p>

                <section className="legal-section">
                    <h2>1. Agreement to Terms</h2>
                    <p>By accessing or using SpinoSoftBits services, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
                </section>

                <section className="legal-section">
                    <h2>2. Services</h2>
                    <p>SpinoSoftBits provides:</p>
                    <ul>
                        <li>Web development and design services</li>
                        <li>E-commerce solutions and Shopify development</li>
                        <li>Digital marketing and SEO services</li>
                        <li>IT consulting and support</li>
                        <li>Maintenance and hosting services</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. Project Terms</h2>
                    <h3>3.1 Pricing</h3>
                    <p>All prices are in USD. Custom quotes are valid for 30 days.</p>
                    
                    <h3>3.2 Payment Terms</h3>
                    <ul>
                        <li>50% deposit required to begin work</li>
                        <li>Remaining balance due upon project completion</li>
                        <li>Monthly services billed in advance</li>
                        <li>Late payments subject to 1.5% monthly interest</li>
                    </ul>

                    <h3>3.3 Timeline</h3>
                    <p>Project timelines are estimates and may vary based on client feedback and revisions.</p>
                </section>

                <section className="legal-section">
                    <h2>4. Client Responsibilities</h2>
                    <ul>
                        <li>Provide necessary content and materials</li>
                        <li>Timely feedback and approvals</li>
                        <li>Accurate business information</li>
                        <li>Legal rights to all provided content</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>5. Intellectual Property</h2>
                    <p>Upon full payment:</p>
                    <ul>
                        <li>Client owns the final deliverables</li>
                        <li>SpinoSoftBits retains the right to showcase work in portfolio</li>
                        <li>Third-party licenses remain with their respective owners</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>6. Revisions and Changes</h2>
                    <ul>
                        <li>Minor revisions included as per package</li>
                        <li>Major scope changes require additional payment</li>
                        <li>Revision requests must be consolidated</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>7. Limitation of Liability</h2>
                    <p>SpinoSoftBits shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the services.</p>
                </section>

                <section className="legal-section">
                    <h2>8. Termination</h2>
                    <p>Either party may terminate services with written notice. Client is responsible for payment of all work completed up to termination date.</p>
                </section>

                <section className="legal-section">
                    <h2>9. Governing Law</h2>
                    <p>These terms shall be governed by the laws of New York State.</p>
                </section>

                <section className="legal-section">
                    <h2>10. Contact Information</h2>
                    <p>
                        SpinoSoftBits<br />
                        Email: spinozadelva@gmail.com<br />
                        Phone: (917) 808-7320
                    </p>
                </section>
            </div>
        </div>
    );
};

export default TermsOfService;